<div class="email-configeration">
  <div class="secondary-details mb-2">
    <span
      >{{ labelName }}
      {{ 'configuration.emailConfiguration.prealertConfiguration' | translate }}</span
    >
    <img style="float: right" src="assets/images/cancel.svg" alt="cancel" mat-dialog-close />
  </div>
  <div class="popup-page">
    <form [formGroup]="preAlertEmailForm" class="mt-2">
      <div class="row mt-2 mb-2">
        <label class="required-field col-md-4 mt-2" for="ctry"
          >{{ 'configuration.emailConfiguration.destinationCountryName' | translate }}:</label
        >
        <div class="col-md-7 form-group address">
          <mat-form-field class="w-100" style="font-size: 14px" appearance="outline">
            <input
              matInput
              placeholder="{{ 'configuration.emailConfiguration.searchCountryName' | translate }}"
              type="text"
              formControlName="Destination"
              [matAutocomplete]="autodest" />
            <mat-autocomplete
              (optionSelected)="destinationCountryselectionChanged($event?.option.value)"
              #autodest="matAutocomplete">
              <mat-option *ngFor="let item of destinationCountryList" [value]="item?.name">
                {{ item?.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <app-error-component
            [controlName]="preAlertEmailForm.get('Destination')"></app-error-component>
          <span class="msg" *ngIf="!isValidCountry">{{
            'configuration.emailConfiguration.selectValidCountryName' | translate
          }}</span>
        </div>
      </div>
      <div class="row mb-2">
        <label class="required-field col-md-4"
          >{{ 'configuration.emailConfiguration.destinationServiceCode' | translate }}:</label
        >
        <div class="col-md-7">
          <input
            specialIsAlphaNumeric
            class="form-control"
            type="text"
            maxlength="3"
            aria-label="babyDestServiceCode"
            formControlName="babyDestServiceCode" />
          <app-error-component
            [controlName]="preAlertEmailForm.get('babyDestServiceCode')"></app-error-component>
        </div>
      </div>
      <div class="row mb-2">
        <label class="required-field col-md-4"
          >{{ 'configuration.emailConfiguration.companyName' | translate }}:</label
        >
        <div class="col-md-7">
          <input
            specialIsAlphaNumeric
            class="form-control"
            type="text"
            formControlName="companyName"
            class="form-control" />
          <app-error-component
            [controlName]="preAlertEmailForm.get('companyName')"></app-error-component>
        </div>
      </div>
      <div class="row mb-2">
        <label class="col-md-4"
          >{{ 'configuration.emailConfiguration.addCommercialInvoice' | translate }}:</label
        >
        <div class="col-md-4 d-flex mb-0 ms-4 mr-2 form-group">
          <mat-checkbox
            (change)="sendCommercialInvoice($event.checked)"
            formControlName="commercialInvoice"
            class="text-wrap"
            id="checkbox">
          </mat-checkbox>
        </div>
      </div>
      <div class="row mb-2">
        <label class="col-md-4 required-field"
          >{{ 'configuration.emailConfiguration.recipientEmailList' | translate }}:</label
        >
        <div class="col-md-7">
          <div class="d-flex align-items-center">
            <input
              type="text"
              class="form-control"
              placeholder="{{
                'configuration.emailConfiguration.EnterEmailIdAndClickButton' | translate
              }}"
              formControlName="email" />
            <i
              [class.disabled]="preAlertEmailForm.get('email').errors?.email"
              matTooltip="{{ 'configuration.emailConfiguration.ClickToAddEmail' | translate }}"
              (click)="addEmailIdToList()"
              class="icon-mat bi bi-file-plus"></i>
          </div>
          <app-error-component [controlName]="preAlertEmailForm.get('email')"></app-error-component>
          <mat-form-field class="example-chip-list" style="font-size: 4px" appearance="none">
            <mat-select
              class="form-control"
              placeholder="{{ 'configuration.emailConfiguration.emailList' | translate }}"
              formControlName="EmailList"
              multiple>
              <mat-option *ngFor="let eachId of emailArray" [value]="eachId">
                {{ eachId }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <app-error-component
            [controlName]="preAlertEmailForm.get('EmailList')"></app-error-component>
        </div>
      </div>

      <div class="row">
        <label class="col-md-4 required-field"
          >{{ 'configuration.emailConfiguration.reportParameters' | translate }}:</label
        >
        <div class="col-md-7">
          <mat-form-field class="example-chip-list" style="font-size: 4px" appearance="none">
            <mat-select
              class="form-control"
              placeholder="{{ 'configuration.emailConfiguration.parameters' | translate }}"
              formControlName="reportparams"
              [(value)]="selectedPreReportParams"
              multiple>
              <mat-option *ngFor="let preReportParam of preReportParams" [value]="preReportParam">
                {{ preReportParam }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <app-error-component
            [controlName]="preAlertEmailForm.get('reportparams')"></app-error-component>
        </div>
      </div>

      <div class="row mb-2">
        <label class="col-md-4"
          >{{ 'configuration.emailConfiguration.senderEmail' | translate }}:
        </label>
        <div class="col-md-7">
          <input
            specialIsAlphaNumeric
            class="form-control"
            type="text"
            aria-label="senderEmail"
            formControlName="senderEmail"
            class="form-control" />
        </div>
      </div>
      <div class="row mb-2">
        <label class="col-md-4 required-field"
          >{{ 'configuration.emailConfiguration.emailBodyContents' | translate }}:</label
        >
        <div class="col-md-7">
          <angular-editor formControlName="emailContent" [config]="editorConfig"></angular-editor>
          <app-error-component
            [controlName]="preAlertEmailForm.get('emailContent')"></app-error-component>
        </div>
      </div>
      <div class="col-md-10 col-md-1 p-0 mt-2">
        <button
          class="primary-btn me-2 text-center"
          [disabled]="preAlertEmailForm.pristine || preAlertEmailForm.invalid || !isValidCountry"
          (click)="saveConfig()"
          type="button">
          {{ 'global.save' | translate }}
        </button>
        <button class="secondary-btn" (click)="closeDailog()" type="button">
          {{ 'global.close' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
